import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SettingsMenuComponent } from '../settings-menu/settings-menu.component';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MobileNavbarComponent } from 'src/components/mobile-navbar/mobile-navbar.component';
import { SettingsForAboutComponent } from '../settings-for-about/settings-for-about.component';
import { SettingsForPrefundProComponent } from '../settings-for-prefund-pro/settings-for-prefund-pro.component';
import { SettingsForAccountComponent } from '../settings-for-account/settings-for-account.component';
import { SettingsForAdvancedComponent } from '../settings-for-advanced/settings-for-advanced.component';
import { SettingsForPreferencesComponent } from '../settings-for-preferences/settings-for-preferences.component';

@Component({
  selector: 'mobile-settings',
  standalone: true,
  imports: [
    CommonModule,
    SettingsMenuComponent,
    MatIcon,
    MobileNavbarComponent,
    SettingsForAboutComponent,
    SettingsForPrefundProComponent,
    SettingsForAccountComponent,
    SettingsForAdvancedComponent,
    SettingsForPreferencesComponent,
  ],
  templateUrl: './mobile-settings.component.html',
  styleUrl: './mobile-settings.component.scss',
})
export class MobileSettingsComponent {
  _state: string = 'preferences';

  @Input() set state(value: string) {
    this._state = value;
    this.stateChange.emit(value);
  }

  get state() {
    return this._state;
  }

  @Output() stateChange = new EventEmitter<string>();

  @Output()
  onHamburgerClick: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  onOpenLoginClick: EventEmitter<void> = new EventEmitter<void>();

  getStateTitle() {
    switch (this.state) {
      case 'prefund_pro':
        return 'Prefund Pro';
      default:
        const title = this.state;
        const capitalizedTitle = title[0].toUpperCase() + title.substring(1);
        return capitalizedTitle;
    }
  }
}
